import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { ReferralBanner } from "@/components/ReferralBanner";
import { Hero } from "@/components/Hero";
import { PromiseBar } from "@/components/PromiseBar";
import { AboutSection } from "@/components/AboutSection";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { ProcessSection } from "@/components/ProcessSection";
import { GallerySection } from "@/components/GallerySection";
import { ReferralSection } from "@/components/ReferralSection";
import { Testimonials } from "@/components/Testimonials";
import { FAQSection } from "@/components/FAQSection";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { api } from "@/lib/api";

export default function LandingPage() {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState({ average: 0, count: 0 });

  const loadReviews = async () => {
    try {
      const [r, s] = await Promise.all([
        api.get("/reviews"),
        api.get("/reviews/stats"),
      ]);
      setReviews(r.data);
      setRating(s.data);
    } catch (_) {}
  };

  useEffect(() => { loadReviews(); }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-white">
      <div className="fixed top-0 inset-x-0 z-40">
        <ReferralBanner />
        <Navbar />
      </div>
      <Hero rating={rating} />
      <PromiseBar />
      <AboutSection />
      <Services />
      <WhyChooseUs />
      <ProcessSection />
      <GallerySection />
      <ReferralSection />
      <Testimonials reviews={reviews} onSubmitted={loadReviews} />
      <FAQSection />
      <QuoteForm />
      <Footer />
      <ChatWidget />
    </div>
  );
}
